import styled from '@emotion/styled';

export const StyledDiv = styled.div<{
  isVisible: boolean;
  hasNavbar: boolean;
  clientWidth: number;
}>`
  position: fixed;
  bottom: ${({ theme, hasNavbar }): number =>
    theme.sizes[!hasNavbar ? 10 : 21]}px;
  left: ${({ clientWidth }): string =>
    `calc(50% - ${clientWidth < 1024 ? clientWidth / 2 - 50 : 200}px)`};
  transform: translateX(-50%);
  height: ${({ theme }): number => theme.sizes[14]}px;
  width: ${({ theme }): number => theme.sizes[14]}px;
  background-color: ${({ theme }): string => theme.colors.ash20};
  z-index: ${({ theme }): number => theme.zIndices[7]};
  box-shadow: ${({ theme }): string => theme.shadows.box};
  border-radius: ${({ theme }): string => theme.radii.xxl};
  display: ${({ isVisible }): string => (isVisible ? 'flex' : 'none')};
  opacity: ${({ isVisible }): number => (isVisible ? 0.75 : 0)};
  transition-duration: 0.75s;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease 0s;
`;
